import { doLogout } from 'actions/authAction';

import { 
  BASE_URL, MASTER_KODE_TRAYEK_REPORT_URL,
  TRAYEK_BALIK_URL, YEAR_MASTER_KODE_TRAYEK,
  MASTER_DATA_TRAYEK_BALIK, SHOW_TABLE_DETAIL_TRAYEK_BALIK,
  MASTER_DATA_DETAIL_TRAYEK_BALIK, KODE_TRAYEK_MASTER_BALIK,
  MASTER_DATA_BARANG_PERUAS, MODAL_BARANG_PERUAS, MASTER_DATA_CONSIGNE,
  MASTER_DATA_PELABUHAN
} from 'actions/constant'

export const showTable = val => {
  return{
    type: SHOW_TABLE_DETAIL_TRAYEK_BALIK,
    val
  }
}

const YearMasterKodeTrayek = (bool, dates) => {
  return {
    type: YEAR_MASTER_KODE_TRAYEK,
    load: bool,
    val: dates
  }
}

const kodeTrayekMaster = (bool, dates) => {
  return {
    type: KODE_TRAYEK_MASTER_BALIK,
    load: bool,
    val: dates
  }
}

const getDataBarangPeruas = (bool, data) => {
  return{
    type: MASTER_DATA_BARANG_PERUAS,
    load: bool,
    val: data
  }
}

const getConsignee = (bool, data) => {
  return {
    type: MASTER_DATA_CONSIGNE,
    isload:bool,
    val:data
  }
}

const getPelabuhan = (bool, data) => {
  return {
    type: MASTER_DATA_PELABUHAN,
    isload:bool,
    val:data
  }
}

export const modalBarangPeruas = data => {
  return{
    type: MODAL_BARANG_PERUAS,
    val: data
  }
}

export const consigneeFetchAll = () => {
  return (dispatch) => {
    dispatch(getConsignee(true,[]))
    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if(token) {
      config = {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + '/consignee', config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(getConsignee(false,[]))
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        if(data.success === true){
          dispatch(getConsignee(false, data.data))
        }else{
          window.alert(data.message)
          dispatch(getConsignee(false,[]))
        }
      })
      .catch((err) => {
        console.log(err, 'err')
        dispatch(getConsignee(false,[]))
      })
  }
}

export const pelabuhanFetchAll = () => {
  return (dispatch) => {
    dispatch(getPelabuhan(true,[]))
    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if(token) {
      config = {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + '/list_pelabuhan', config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        if(data.status === 200){
          dispatch(getPelabuhan(false, data.data))
        }else{
          window.alert(data.message)
          dispatch(getPelabuhan(false,[]))
        }
      })
      .catch((err) => {
        console.log(err, 'err')
        dispatch(getPelabuhan(false,[]))
      })
  }
}

export const dataBarangPerRuas = data => {
  return (dispatch) => {
    dispatch(getDataBarangPeruas(true, []))
    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if(token) {
      config = {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + TRAYEK_BALIK_URL + `muatan/${data.id}/${data.kode}`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        if(data.status === 200){
          dispatch(modalBarangPeruas(true))
          dispatch(getDataBarangPeruas(false, data.data))
        }else{
          dispatch(getDataBarangPeruas(false, []))
        }
        
      })
      .catch((err) => {
        console.log(err, 'err cuk')
      })
  }
}

export const masterDataTrayekBalik = (bool, data) => {
  return{
    type: MASTER_DATA_TRAYEK_BALIK,
    load: bool,
    val: data
  }
}

export const masterDataDetailTrayekBalik = (bool, data) => {
  return{
    type: MASTER_DATA_DETAIL_TRAYEK_BALIK,
    load: bool,
    val: data
  }
}

export const dataDetailTrayekBalik = data => {
  return async(dispatch) => {
    if(data.table === true){
      dispatch(showTable(false))
    }
    await dispatch(masterDataDetailTrayekBalik(true, {data:[]}))
    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if(token){
      config = {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + TRAYEK_BALIK_URL + `details?kodeTrayek=${data.kode}&year=${data.date}&consignee=${data.consigne}&pol=${data.pol}&pod=${data.pod}&trayek=${data.trayek}`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then((response) => response.json())
      .then((res) => {
        if(res.status === 200){
          if(data.table === true){
            dispatch(showTable(true))
          }
          dispatch(masterDataDetailTrayekBalik(false, res))
        }else{
          window.alert(res.message)
          dispatch(masterDataDetailTrayekBalik(false, {data:[]}))
        }
      })
      .catch((err) => {
        console.log(err, 'err')
        dispatch(masterDataDetailTrayekBalik(false, {data:[]}))
      })
  }
}

export const dataTrayekBalik = data => {
    return (dispatch) => {
      dispatch(masterDataTrayekBalik(true, {data:[]}))
      let token = localStorage.getItem('tolaut@token') || null
      let config = {}
      if(token) {
          config = {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        } else {
          throw Error("Authentication error")
        }
        fetch(BASE_URL + TRAYEK_BALIK_URL + `header?year=${data.date}&operator=${data.op}&trayek=${data.kode}`, config)//&kode=${data.kode}
          .then((response) => {
            if (response.status === 401) {
              dispatch(doLogout())
            }
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then((response) => response.json())
          .then((data) => {
            dispatch(masterDataTrayekBalik(false, data))
          })
          .catch((err) => {
            console.log(err, 'err')
          })
    }
}

const compare = (a, b) => {
  // Use toUpperCase() to ignore character casing
  const YearA = a.value.toUpperCase();
  const YearB = b.value.toUpperCase();

  let comparison = 0
  if (YearA > YearB) {
    comparison = 1;
  } else if (YearA < YearB) {
    comparison = -1;
  }
  return comparison;
}

export const masterKodeTrayekFetchAll = () => {
    return (dispatch) => {
        dispatch(YearMasterKodeTrayek(true, []))
        dispatch(kodeTrayekMaster(true, []))
        let token = localStorage.getItem('tolaut@token') || null
        let config = {}
        if(token) {
            config = {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
          } else {
            throw Error("Authentication error")
          }
          fetch(BASE_URL + MASTER_KODE_TRAYEK_REPORT_URL, config)
          .then((response) => {
            if (response.status === 401) {
              dispatch(doLogout())
            }
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then((response) => response.json())
          .then((data) => {
              if(data.status === 200){
                  if(data.data.data.length > 0){
                    const dates = []
                    const kode = []
                    data.data.data.map((val) => {
                        // const kt = val.kode_trayek.substring(0,4)
                        const kt = val.kode_trayek.split(' ')[0]
                        if(!kode.some(id => id.value === kt && id.tahun === val.tahun_trayek)){
                          let obj = {value: kt, label: kt, tahun: val.tahun_trayek}
                          kode.push(obj)
                        }

                        if(!dates.some(id => id.value === val.tahun_trayek)){
                            let obj = {value:val.tahun_trayek, label:val.tahun_trayek}
                            dates.push(obj)
                        }
                        return true
                    })
                    dates.sort(compare)
                    dispatch(YearMasterKodeTrayek(false, dates))
                    dispatch(kodeTrayekMaster(false, kode))
                  }else {
                    const dates = [{value:'', label:'No Data Found'}]
                    dispatch(YearMasterKodeTrayek(false, dates))
                  }
              }
          })
          .catch((err) => {
            console.log(err, 'err')
          })
    }
}

export const MUATAN_PER_VOYAGE_NEW_LOADING = 'MUATAN_PER_VOYAGE_NEW_LOADING';
export const MUATAN_PER_VOYAGE_NEW_ERROR = 'MUATAN_PER_VOYAGE_NEW_ERROR';
export const MUATAN_PER_VOYAGE_NEW_SUCCESS = 'MUATAN_PER_VOYAGE_NEW_SUCCESS';

const muatanPerVoyageLoading = (bool, kode) => {
  return {
    type: MUATAN_PER_VOYAGE_NEW_LOADING,
    kode: kode,
    loading: bool
  }
}

const muatanPerVoyageSuccess = (bool, kode, data) => {
  return{
    type: MUATAN_PER_VOYAGE_NEW_SUCCESS,
    kode: kode,
    success: bool,
    data
  }
}

const muatanPerVoyageError = (bool, kode) => {
  return {
    type: MUATAN_PER_VOYAGE_NEW_ERROR,
    kode: kode,
    error: bool
  }
}

export const muatanPerVoyage = (kodeTrayek, tahunTrayek) => {
  let token = localStorage.getItem('tolaut@token') || null;

  return dispatch => {
    dispatch(muatanPerVoyageLoading(true, kodeTrayek));
    dispatch(muatanPerVoyageSuccess(false, kodeTrayek, []));
    dispatch(muatanPerVoyageError(false, kodeTrayek));

    fetch(BASE_URL + 'muatanpervoyage', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        kode: kodeTrayek,
        tahun: tahunTrayek
      })
    })
    .then(response => {
      if (response.status === 401) {
        dispatch(doLogout())
      }
      if (!response.ok) {
        throw Error(response.statusText)
      }
      return response;
    })
    .then(response => response.json())
    .then(data => {
      dispatch(muatanPerVoyageLoading(false, kodeTrayek));
      if(data.status === 200){
        dispatch(muatanPerVoyageSuccess(true, kodeTrayek, data))
      }else{
        alert(data.message)
      }
    })
    .catch(err => {
      console.log(err);
      dispatch(muatanPerVoyageLoading(false, kodeTrayek));
      dispatch(muatanPerVoyageError(true, kodeTrayek));
    })
  }

}

export const DETAIL_PER_VOYAGES = 'DETAIL_PER_VOYAGES';

const getDetailPerVoyage = (bool, data) => {
  return {
    type: DETAIL_PER_VOYAGES,
    isload:bool,
    val:data
  }
}

const getDetailContainer = (bool, data) => {
  return {
    type: "DETAIL_CONTAINER",
    isload:bool,
    val:data
  }
}

export const DetailPerVoyage = (data) => {
  let token = localStorage.getItem('tolaut@token') || null;

  return dispatch => {
    dispatch(getDetailPerVoyage(true, []));

    fetch(BASE_URL + 'detailpervoyage', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.status === 401) {
        dispatch(doLogout())
      }
      if (!response.ok) {
        throw Error(response.statusText)
      }
      dispatch(getDetailPerVoyage(false, []));
      return response;
    })
    .then(response => response.json())
    .then(data => {
      dispatch(getDetailPerVoyage(false, data));
    })
    .catch(err => {
      
      dispatch(getDetailPerVoyage(false, []));
    })
  }

}

export const DetailContainerAction = (data) => {
  let token = localStorage.getItem('tolaut@token') || null;

  return dispatch => {
    dispatch(getDetailContainer(true, []));
    fetch(BASE_URL + 'detailchart', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.status === 401) {
        dispatch(doLogout())
      }
      return response;
    })
    .then(response => response.json())
    .then(data => {
      if(data.status === 200){
        dispatch(getDetailContainer(false, data.data));
      }else{
        window.alert(data.message)
        dispatch(getDetailContainer(false, []));
      }
      
    })
    .catch(err => {
      window.alert(err)
      dispatch(getDetailContainer(false, []));
    })
  }

}

export const SET_DETAIL_CONTAINER = 'SET_DETAIL_CONTAINER';

const setFilterDetailContainer = (data) => {
  return {
    type: SET_DETAIL_CONTAINER,
    val: data
  };
};

export const filterDetailContainerAction = (data) => {
  return dispatch => {
    dispatch(setFilterDetailContainer(data));
  };
};